var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.agreement)?_c('div',[_c('RenderChildSupportCalculations')],1):_c('div',[_c('RenderChildSupportStandalone')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }